export default __webpack_public_path__ + "static/media/maxi-itzkoff@2x.c0ddb549.png";